var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"default-portfolio-button",attrs:{"label":"Generate Report","type":"is-primary","icon-pack":"fas","icon-left":"file-pdf"},on:{"click":function($event){return _vm.goToReportBuilder(_vm.portfolio)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }